'use strict';

export default class LiveChat {
  constructor() {
    var self = this;
    $(document).ready(function() {
      self.initLiveChat();
    })
  }

  initLiveChat() {
    var LHC_API = {};
    window.LHC_API = LHC_API || {};
    var host = 'abachat.launtel.net.au';
    var lhc_base_url = 'https://' + host + '/lhc_web/index.php/';
    window.LHCChatOptions = {}; 
    var prefillMembersDetail = this.getUserData();
    
    LHCChatOptions.attr_prefill_admin = new Array(); 
    for(var i = 0; i < prefillMembersDetail.length; i++) {
      LHCChatOptions.attr_prefill_admin.push(prefillMembersDetail[i]);
    }

    LHC_API.args = {
      mode: 'widget',
      lhc_base_url: lhc_base_url,
      wheight: 450,
      wwidth: 350,
      pheight: 520,
      pwidth: 500,
      leaveamessage: true,
      check_messages: false,
      //offline_redirect:'https://www.breastfeeding.asn.au/node/37131',
      offline_redirect: '#',
      loadcb: widgetV2Callbacks,
      //fresh:false,
      department: [1, 2]
    };

    (function () {
      var po = document.createElement('script');
      po.type = 'text/javascript';
      po.setAttribute('crossorigin', 'anonymous');
      po.setAttribute('scope', 'LHC');
      po.async = true;
      var date = new Date();
      po.src = 'https://' + host + '/lhc_web/design/defaulttheme/js/widgetv2/index.js?' + ("" + date.getFullYear() + date.getMonth() + date.getDate());
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    var instance;

    function widgetV2Callbacks(loadcb) {
      loadcb.eventEmitter.addListener('offlineClickAction', function () {
        var ttipdiv = document.getElementById('ttipdiv');

        if (instance == null) {
          instance = tippy([ttipdiv], {
            content: document.getElementById('ttipcontent').innerHTML,
            trigger: 'click',
            theme: 'light-border',
            animation: 'fade',
            placement: 'auto',
            popperOptions: {
              placement: 'auto'
            },
            interactive: true
          })[0];
        }

        if (instance != null) instance.show();
      });
    }
  }

  getUserData() {
    var block  = $(`#block-views-block-user-information-block-current-user-detail`);
    
    var userData = [];
    var dataElement = null;

    if(block.find('.views-row').length > 1) {
      dataElement = block.find('.views-row.Current .user-membership-data');
    } else {
      dataElement = block.find('.user-membership-data');
    }
    
    var name = dataElement.data('name');
    if(name) 
      userData.push({index: 'username',value: name});

    var email = dataElement.data('email');
    if(email) 
      userData.push({index: 'email',value: email});
    
    var abanumber = dataElement.data('abanumber');
    if(abanumber) 
      userData.push({index: 'abanumber',value: abanumber});
    
    var postcode = dataElement.data('postcode');
    if(postcode) 
      userData.push({index: 'postcode',value: postcode});
    
    return userData;
  }
}
